export default __webpack_public_path__ + "static/media/md.40f2fa89.jpg";